module.exports = __webpack_public_path__ + "img/google.9d309a82.svg";